import React from 'react';
import {
  Routes,
  Route,
  useParamsLegacy as useParams,
} from '@leagueplatform/routing';
import { FocusAreaPage } from './pages/focus-area-page/focus-area-page.component';

const Wrapper = ({
  noSolutionsMessage,
}: {
  noSolutionsMessage?: React.ReactNode;
}) => {
  const { category, topic } = useParams<{ category: string; topic: string }>();
  return (
    <FocusAreaPage
      match={{ params: { category, topic } }}
      noSolutionsMessage={noSolutionsMessage}
    />
  );
};

export const HealthNeedPagesRoutes = ({
  noSolutionsMessage,
}: {
  noSolutionsMessage?: React.ReactNode;
}): JSX.Element => (
  <Routes>
    <Route
      path=":category/:topic"
      element={
        <Wrapper
          // Temporary Solution to pass in the Chat Banner until Chat is modularized
          noSolutionsMessage={noSolutionsMessage}
        />
      }
    />
  </Routes>
);
